import { chainToPlatform, platformToAddressFormat } from "@wormhole-foundation/sdk-base";
//TODO BRRRR circular include!!
//I have yet to figure out how to get the equivalent of a forward declaration to work (without
//  yet again having to rely on global scope...)
//I first tried `declare class UniversalAddress {};` but this actually introduces a new, separate
//  type in this module rather than telling the compiler that we already have this type elsewhere
//I could also create an interface via `interface IUnverisalAddress {}` but that seems like an
//  even worse solution, as is just throwing everything into this file here and just brushing
//  things under the rug by not separating them out.
import { UniversalAddress } from "./universalAddress.js";
export function isChainSpecificAddress(thing) {
    return typeof thing === "object" && "setChain" in thing;
}
const nativeFactory = new Map();
export function registerNative(platform, ctr) {
    if (nativeFactory.has(platform))
        return;
    // TODO:
    // throw new Error(`Native address type for platform ${platform} has already registered`);
    nativeFactory.set(platform, ctr);
}
export function nativeIsRegistered(chain) {
    const platform = chainToPlatform.get(chain);
    return nativeFactory.has(platform);
}
/** Parse an address into its NativeAddress representation */
export function toNative(chain, ua) {
    const platform = chainToPlatform.get(chain);
    const nativeCtr = nativeFactory.get(platform);
    if (!nativeCtr)
        throw new Error(`No native address type registered for platform ${platform}, import the platform directly or, if using sdk package, import the addresses conditional export`);
    try {
        const nativeAddress = new nativeCtr(ua);
        if (isChainSpecificAddress(nativeAddress)) {
            // idk why but this typeguard doesnt actually work?
            nativeAddress.setChain(chain);
        }
        return nativeAddress;
    }
    catch (e) {
        const err = `Error parsing address as a native ${chain} address: ${e.message}`;
        if (UniversalAddress.instanceof(ua)) {
            throw err;
        }
        else {
            // If we were given a string or Uint8Array value, which is ambiguously either a
            // NativeAddress or UniversalAddress, and it failed to parse directly
            // as a NativeAddress, we try one more time to parse it as a UniversalAddress
            // first and then convert that to a NativeAddress.
            return (new UniversalAddress(ua)).toNative(chain);
        }
    }
}
export function toUniversal(chain, address) {
    const platform = chainToPlatform.get(chain);
    return new UniversalAddress(address, platformToAddressFormat.get(platform));
}
//# sourceMappingURL=address.js.map